<template>
    <vx-expandable-card>
        <template v-slot:content>
            <div class="flex flex-col gap-4">
                <div>
                    <vx-label size="md">Name</vx-label>

                    <vx-input
                        data-test="name-input"
                        autofocus
                        v-model="form.name"
                        size="lg"
                        placeholder="Enter organizational unit name"
                        :error="displayFirstError(validate.name.$errors)"
                    ></vx-input>
                </div>

                <div>
                    <vx-label size="md">Team</vx-label>

                    <vx-selectable
                        v-model="form.team_id"
                        :options="teams"
                        @search="search"
                        size="lg"
                        label="name"
                        :reduce="(option) => option.id"
                        :clearable="false"
                        placeholder="Select a team"
                        :error="displayFirstError(validate.team_id.$errors)"
                    ></vx-selectable>
                </div>

                <div>
                    <vx-label size="md">HubSpot Company ID </vx-label>

                    <hubspot-company-id-input
                        v-model="form.hubspot_company_id"
                        placeholder="HubSpot Company ID"
                        size="lg"
                        :error="displayFirstError($externalResults.hubspot_company_id)"
                    />
                </div>
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxInput, VxLabel, VxSelectable } from '@voxie/frontend-components';
import HubspotCompanyIdInput from '~/components/general/HubspotCompanyIdInput.vue';
import { ref } from 'vue';
import { adminTeamsClient } from '~/services';
import { displayFirstError, groupAndOrgUnitName } from '~/utils/validation';
import { useFormRequestHandler } from '~/composables/useFormRequestHandler';
import debounce from '~/utils/debounce';
import { maxLength, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

const { $externalResults } = useFormRequestHandler();

const form = defineModel({
    required: true,
    type: Object,
});

const teams = ref([]);

const search = debounce((query) => {
    adminTeamsClient
        .getTeams({
            query,
            status: 'active',
            has_feature: 'contact_groups',
        })
        .then(
            (res) =>
                (teams.value = res.data.data.map((team) => ({
                    ...team,
                    name: `${team.id} - ${team.name}`,
                })))
        );
});

search();

const validate = useVuelidate(
    {
        name: {
            required,
            maxLength: maxLength(80),
            format: groupAndOrgUnitName,
        },
        team_id: {
            required,
        },
        hubspot_company_id: {},
    },
    form
);
</script>
